import React from 'react';
import PropTypes from 'prop-types';
import {apiUrl} from '../api-base.js';

const AuthContext = React.createContext({
    user: null,
    isLoading: true,
    isAuthenticated: false,
    refresh: () => {}
});

class AuthProvider extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            user: null,
            isLoading: true
        };
        this.refresh = this.refresh.bind(this);
    }
    componentDidMount () {
        this.refresh();
    }
    refresh () {
        fetch(apiUrl('/api/auth/user'), {credentials: 'include'})
            .then(res => {
                const contentType = res.headers.get('content-type') || '';
                if (res.ok && contentType.includes('application/json')) {
                    return res.json();
                }
                return null;
            })
            .then(user => {
                this.setState({user, isLoading: false});
            })
            .catch(() => {
                this.setState({user: null, isLoading: false});
            });
    }
    render () {
        return (
            <AuthContext.Provider value={{
                user: this.state.user,
                isLoading: this.state.isLoading,
                isAuthenticated: !!this.state.user,
                refresh: this.refresh
            }}>
                {this.props.children}
            </AuthContext.Provider>
        );
    }
}

AuthProvider.propTypes = {
    children: PropTypes.node
};

export {AuthContext, AuthProvider};
export default AuthContext;
